import React from 'react';
import classNames from 'classnames';

import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import IconChevronRight from '@zvuk-b2b/react-uikit/ui/icons/ChevronRight';
import { Link } from 'application/providers/RouterProvider';
import { IVideoStream } from 'application/pages/PointsGroupsPage/types';
import styles from './index.module.scss';
import VideoStreamPreviewItemContent from '../VideoStreamPreviewItemContent';
import VideoStreamPreviewItemSkeleton from './VideoStreamPreviewItemSkeleton';
import { TEXTS } from '../../texts';

export type StreamPreviewItemProps = {
  stream?: IVideoStream | null;
  className?: string;
  loading?: boolean;
  withLink?: boolean;
};

const VideoStreamPreviewItem: React.FC<StreamPreviewItemProps> = ({ stream, className, loading, withLink }) => (
  <div className={classNames(styles.StreamPreviewItem, className)}>
    {stream && (
      <VideoStreamPreviewItemContent
        previewUrl={stream.previewUrl || undefined}
        title={stream.title}
        description={stream.description}
        duration={stream.duration}
        filesCount={stream?.videoMediafiles?.length || 0}
      />
    )}
    {loading && <VideoStreamPreviewItemSkeleton />}

    {!stream && !loading && <h4>{TEXTS.VIDEO_STREAM_FALLBACK}</h4>}
    {withLink && stream?.id && (
      <Link to={`/video-streams/${stream?.id}`}>
        <IconButton
          isDisabled={!stream?.id}
          elementId="navigate_to_point">
          <IconChevronRight />
        </IconButton>
      </Link>
    )}
  </div>
);

export default VideoStreamPreviewItem;
